import React from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import { WithApp } from 'contexts/appContext';

export default WithApp(function ModalDivision(props) {
  const division = props.model;

  return (
    <>
      <Modal
        title={`División de Arcor`}
        model={division}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity='sale/arcor_divisions'
      >
        <TextField
          label="Código"
          fullWidth
          type="text"
          name="code"
          margin="normal"
          defaultValue={!!division ? division.code : ''}
          required
        />
        <TextField
          label="Descripción"
          fullWidth
          type="text"
          name="description"
          margin="normal"
          defaultValue={!!division ? division.description : ''}
          required
        />
      </Modal>
    </>
  );
});
